<template>
    <div class="meeting-invite-form">
        <form method="post" v-on:submit="onSubmit($event)" ref="form">
            <div class="form-row">
                <md-field v-bind:class="{'md-invalid': !!errors['lastname']}">
                    <md-input :placeholder="$t('meeting-invite.lastname')" name="lastname" v-model="fData.lastname" :disabled="submitting ? 'disabled' : null" required autofocus></md-input>
                    <span class="md-error">{{ errors['lastname'] ? errors['lastname'][0] : '' }}</span>
                </md-field>
                <md-field v-bind:class="{'md-invalid': !!errors['firstname']}">
                    <md-input :placeholder="$t('meeting-invite.firstname')" name="firstname" v-model="fData.firstname" :disabled="submitting ? 'disabled' : null" required autofocus></md-input>
                    <span class="md-error">{{ errors['firstname'] ? errors['firstname'][0] : '' }}</span>
                </md-field>
            </div>
            <div class="form-row">
                <md-field v-bind:class="{'md-invalid': !!errors['email']}">
                    <md-input :placeholder="$t('meeting-invite.email')" name="email" v-model="fData.email" :disabled="submitting ? 'disabled' : null" autofocus></md-input>
                    <span class="md-error">{{ errors['email'] ? errors['email'][0] : '' }}</span>
                </md-field>
            </div>
            <div class="form-row">
                <phone-field :show-label="false" required name="phone" v-model="fData.phone" :errors="errors['phone']" :label="$t('meeting-invite.phone')" country-id="1" ref="phoneInput" :disabled="submitting ? 'disabled' : null"></phone-field>
                <md-field v-bind:class="{'md-invalid': !!errors['company']}">
                    <md-input :placeholder="$t('meeting-invite.company')" name="company" v-model="fData.company" :disabled="submitting ? 'disabled' : null" autofocus></md-input>
                    <span class="md-error">{{ errors['company'] ? errors['company'][0] : '' }}</span>
                </md-field>
            </div>
            

            <submit-button type="submit" class="registration-standalone-button" :submitting="submitting" :label="$t('meeting-invite.register')" v-on:click="onSubmit()"></submit-button>
        </form>
    </div>
</template>

<script>
    import PhoneField from './PhoneFieldComponent.vue';

    export default {
        components: {
            PhoneField,
        },
        data() {
            return {
                fData: {
                    email: '',
                    phone: '',
                    lastname: '',
                    firstname: '',
                    company: '',
                },
                errors: {
                    email: null,
                    phone: null,
                    lastname: null,
                    firstname: null,
                    company: null,
                },
                submitting: false
            };
        },
        methods: {
            onSubmit(event) {
                this.submitting = true;
                for (var i of Object.keys(this.errors)) {
                    this.errors[i] = null;
                }
                if (event) {
                    event.preventDefault();
                }
                axios.post(this.$refs.form.action, this.fData).then((response) => {
                    if (response['status'] == 'ok') {
                        window.location = response.data['redirect'];
                    } else {
                        this.submitting = false;
                    }
                }).catch((error) => {
                    this.submitting = false;
                    for (var i of Object.keys(this.errors)) {
                        this.errors[i] = error.response.data.errors[i];
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/widgets/MeetingInviteForm.vue